<p class="text-center text-uppercase title mb-1">{{ 'page1Header' | translate }}</p>
<p class="subtitle">{{ 'page1subHeader' | translate }}</p>

<div class="mt-4 d-flex flex-grow-1">
  <form [formGroup]="form" class="d-flex flex-grow-1 flex-column" (ngSubmit)="goToStep2()">
    <app-vc-input
      name="firstName"
      label="labels.firstName"
      [control]="form.controls.firstName"
      [placeholder]="'placeholders.firstName' | translate"
      [required]="true"
      autocomplete="given-name"
      (enter)="goToStep2()"
    />
    <app-vc-input
      name="lastName"
      label="labels.lastName"
      [control]="form.controls.lastName"
      [placeholder]="'placeholders.lastName' | translate"
      [required]="true"
      autocomplete="family-name"
      (enter)="goToStep2()"
    />
    <app-vc-input
      name="email"
      label="labels.email"
      type="email"
      [control]="form.controls.email"
      [placeholder]="'placeholders.email' | translate"
      [required]="true"
      autocomplete="email"
      (enter)="goToStep2()"
    />
    <app-vc-input
      name="phone"
      label="labels.phone"
      type="tel"
      [control]="form.controls.phone"
      [placeholder]="'placeholders.phone' | translate"
      [required]="true"
      autocomplete="tel"
      (enter)="goToStep2()"
    />
    <app-vc-input
      class="custom-vc-input"
      name="password"
      label="labels.password"
      type="password"
      [control]="form.controls.password"
      [placeholder]="'placeholders.password' | translate"
      [required]="true"
      autocomplete="new-password"
      [hideErrors]="true"
      (enter)="goToStep2()"
      (focused)="passwordFocused.set($event)"
    />
    <app-password-tips [errors]="passwordErrors()" [active]="!!form.controls.password.value" [open]="passwordTipsOpen()" />

    <div class="mt-auto">
      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-lg btn-block m-t-10" [class.btn-primary]="form.valid" [class.btn-default]="!form.valid">
          {{ 'labels.next' | translate }}
        </button>
      </div>

      <div class="footer-text">
        <span class="text-nowrap">{{ 'labels.alreadyHaveAccount' | translate }}</span> &nbsp;
        <a class="text-nowrap text-primary" [href]="signInUrl">{{ 'labels.signInHere' | translate }}</a>
      </div>
    </div>
  </form>
</div>
